/**
 * 模組頁面代碼 : 1320-UI-04
 * 頁面說明 : 角色維護列表畫面
 * @module web/modules/department/components/DepartmentListModal
 */

// ----- import from npm modules ----
import React, {useEffect} from 'react';

// ----- import from local modules -----
import {
  AccessModeEnums,
  ModuleEnums,
  BaseComponent,
} from '../../../components/BaseComponent';
import enumList from 'web/utils/enumList';
import {useDepartmentListModal} from '../hooks/useDepartmentListModal';

const DepartmentListModal = React.forwardRef((props, ref) => {
  const {
    onDepartment,
    departmentList,
    onEditDepartmentStatus,
    needDepartmentListLoad,
    setNeedDepartmentListLoad,
  } = props;
  const baseComponent = new BaseComponent(props);
  const {prepareDepartmentListTable} = useDepartmentListModal(
    baseComponent,
    departmentList,
  );

  // // 當表格的容器可見後，調整列寬
  const adjustTableWhenVisible = () => {
    const tableContainer = document.querySelector('#datatable__departmentList'); // 假設這是表格的容器
    if (tableContainer && tableContainer.offsetParent !== null) {
      const t = prepareDepartmentListTable();
      t.columns.adjust().draw();
    } else {
      setTimeout(adjustTableWhenVisible, 100); // 容器不可見，稍後再嘗試
    }
  };

  useEffect(() => {
    if (needDepartmentListLoad) {
      setNeedDepartmentListLoad(false);

      const maskElement = document.querySelector('#modal-mask');
      // 顯示遮罩
      maskElement.style.opacity = '0.5';

      //   // 隱藏遮罩
      maskElement.style.opacity = '0';
      setTimeout(() => {
        maskElement.style.display = 'none';
      }, 200);

      // 重新繪製表格
      adjustTableWhenVisible();
    }
  }, [needDepartmentListLoad]);

  useEffect(() => {
    const handleChange = (event) => {
      const checkbox = event.target.closest('input[type="checkbox"]');
      if (checkbox && checkbox.id.startsWith('eab-department-')) {
        const index = parseInt(checkbox.id.split('-')[2]);
        const mode = checkbox.checked
          ? enumList.alertModalModeEnums.enable
          : enumList.alertModalModeEnums.disable;
        const updateDepartment = departmentList[index];
        if (updateDepartment) {
          let message = '';
          if (mode === enumList.alertModalModeEnums.enable) {
            message = `啟用 [ ${updateDepartment.departmentName} ]`;
          } else {
            message = `停用 [ ${updateDepartment.departmentName} ]`;
          }
          onEditDepartmentStatus(
            mode,
            message,
            updateDepartment.departmentCode,
          );
        } else {
          console.log('No role found at index:', index);
        }
      }
    };
    const handleClick = (event) => {
      const button = event.target.closest('.btn');
      if (
        button &&
        button.id.startsWith('edit-department-') &&
        departmentList.length > 0
      ) {
        const index = parseInt(button.id.split('-')[2]);
        const departmentCode = departmentList[index].departmentCode;
        onDepartment(enumList.modalMode.edit, departmentCode);
      }
    };
    if (departmentList && ref.current?._dialog) {
      ref.current?._dialog.addEventListener('change', handleChange);
      ref.current?._dialog.addEventListener('click', handleClick);
    }

    return () => {
      if (ref.current?._dialog) {
        ref.current?._dialog.removeEventListener('change', handleChange);
        ref.current?._dialog.removeEventListener('click', handleClick);
      }
    };
  }, [departmentList]);

  return (
    <div
      ref={ref}
      className="modal fade"
      id="modalRoleList"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="modalRoleListLabel"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <form
          className="modal__form modal-content needs-validation"
          id="modalRoleListForm"
          noValidate
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="modalRoleListLabel">
              <div className="modal__title__badge">
                <svg className="badge__icon" aria-hidden="true">
                  <use href="#ico-users-edit"></use>
                </svg>
              </div>
              <div className="modal__title__text">部門管理</div>
            </h1>
            <button
              type="button"
              className="btn-close btn-cancel"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div id="modal-mask" className="modal-mask"></div>
            <div className="datatable__tool mb-2">
              <div className="d-flex align-items-center gap-2 ms-auto">
                {baseComponent.checkPermission(
                  ModuleEnums.ROLE,
                  AccessModeEnums.CREATE,
                ) && (
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    id="modalRoleBtnNew"
                    onClick={() => onDepartment()}
                  >
                    <svg className="btn__icon me-2" aria-hidden="true">
                      <use href="#ico-plus"></use>
                    </svg>
                    新增
                  </button>
                )}
              </div>
            </div>
            <div className="datatable__data">
              <table
                id="datatable__departmentList"
                className="display table table-hover align-middle nowrap"
                style={{width: '100%'}}
              ></table>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
});

export default DepartmentListModal;
